export default "__VITE_ASSET__iyAqzdRN__"